import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import { StorageService } from "../../services/storage-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { ReportService } from "../../services/report-service";
import { NotifyService } from "../../services/notify-service";

export class DataExportAdminController {

    public static $inject = ["$scope", "$window", "$q", "entityConfigService", "reportService", "notifyService", "storage"];

    public selectedCharTypeId: number = null; // current selected char type
    public selectedTemplateId: number = null; // current selected template
    public selectedRelatedCharTypeId: number = null; // current selected char type of the related entity
    public selectedRelatedTemplateId: number = null; // current selected template of the related entity
    public itemRows: Models.IEntitySearchDoc[] = []; // search result item rows
    public page: number = 1; // current page
    public pageCount: number = 1; // current page count of search results
    public charTypes: Models.ICharacteristicType[] = []; //char type data for select box
    public relatedCharTypes: Models.ICharacteristicType[] = []; //char type data for select box of the related entity
    public templates: Models.ICharacteristicTemplate[] = []; // template data for select box
    public relatedTemplates: Models.ICharacteristicTemplate[] = []; // template data for select box of the related entity
    public selectedChar: Models.ICharacteristic = null; // char data for multiple select box
    public selectedRelatedChar: Models.ICharacteristic = null;
    public sortField: string = "";
    public sortDir: number = 0;
    public numFound: number;
    public reportingChars: Models.IDynamicReportColumnChar[] = [];
    public savedQueryReports: Models.ISavedQueryReport[] = [];
    public selectedReport: Models.ISavedQueryReport = null;
    private savedReportNames: string[] = [];
    public reportName: string = "";
    private allColumnChars: { [charTypeID: number]: any } = {};
    public allColumnFilteredChars: { [charTypeID: number]: any } = {};
    private allRelatedChars: { [charTypeID: number]: any } = {};
    public allRelatedFilteredChars: { [charTypeID: number]: any } = {};
    public showRelated: boolean = false;
    public selectedRelatedTemplatePartyId: number = null;
    public selectedRelatedTemplateParties: Models.IParty[] = [];
    public rowCount: number = 25;
    private removedAllColumnCharFromReportingChars: boolean = false;

    private readonly _savedDataExportReportKey: string = `dynamicExport_${Consts.userDivAppUrlHash}`;
    private readonly _confirmationMessage: string = "Are you sure?";
    private readonly _bustedMessage: string = "Unexpected response encountered. Please try again.";

    public constructor(private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private entityConfigService: EntityConfigService,
        private reportService: ReportService,
        private notifyService: NotifyService,
        private storage: StorageService) {
        this.entityConfigService = entityConfigService;

        $scope.$watch(() => this.selectedCharTypeId, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.CharTypeChanged();
            }
        });

        $scope.$watch(() => this.selectedRelatedCharTypeId, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.RelatedCharTypeChanged();
            }
        });

        $scope.$watch(() => this.selectedTemplateId, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.TemplateChanged();
            }
        });

        $scope.$watch(() => this.selectedRelatedTemplateId, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.RelatedTemplateChanged();
            }
        });

        $scope.$watch(() => this.sortField,
            (newValue: string, oldValue: string) => {
                if (newValue != oldValue) {
                    this.ExecuteReport();
                }
            }, true);

        $scope.$watch(() => this.rowCount, (newValue: number, oldValue: number) => {
            if (newValue != oldValue) {
                this.ExecuteReport();
            }
        });

        $scope.$watch(() => [this.page, this.sortDir],
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    this.ExecuteReport();
                }
            }, true);

        $scope.$watch(() => this.reportingChars, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                if (newValue.length > 0) {
                    this.ExecuteReport();
                }
            }
        }, true);

        $scope.$watch(() => this.selectedChar, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.AddCharacteristicToReport(newValue);
            }
        }, true);

        $scope.$watch(() => this.selectedRelatedChar, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.AddRelatedCharacteristicToReport(newValue);
            }
        }, true);

        $scope.$watch(() => this.selectedReport, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.LoadReport();
            }
        }, true);
    }

    public ResetAll() {
        this.selectedCharTypeId = null;
        this.selectedTemplateId = null;
        this.selectedReport = null;
        this.relatedCharTypes = [];
        this.selectedRelatedCharTypeId = null;
        this.relatedTemplates = [];
        this.selectedRelatedTemplateId = null;
        this.selectedRelatedTemplateParties = [];
        this.selectedRelatedTemplatePartyId = null;
        this.allRelatedFilteredChars = [];
        this.ResetColumns();
    }

    public ResetColumns() {
        this.reportingChars = [];
        this.showRelated = false;
        this.page = 1;
        this.pageCount = 1;
        this.sortDir = 0;
        this.sortField = "";
        this.selectedChar = null;
        this.itemRows = [];
    }

    public ExportReport() {
        var query = this.reportingChars.map(x => x.tagName);

        var reportRequest: Models.IDynamicReportRequest = {
            ct: this.selectedCharTypeId, // slected char type
            t: this.selectedTemplateId, // selected template
            cols: query, // selected characteristics
            relIndId: this.selectedRelatedTemplatePartyId,
            p: this.page - 1, // the current page
            r: 10, // rows to return
            sf: this.sortField, // sort Field
            sd: this.sortDir // sort direction 0 - ascending, 1 - descending
        };

        if (this.selectedCharTypeId != null && this.selectedTemplateId != null && this.reportingChars != []) {
            // call service to get the report results exported to excell file and email file to user for download
            this.notifyService.startProgress(); // start progress bar
            this.reportService.exportReport(reportRequest)
                .then((result) => {
                    alert("An email with a link to download this export has been sent to your email address.");
                })
                .catch((reason: any) => {
                    alert(this._bustedMessage);
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    public Init() {
        this.entityConfigService.getCharacteristicTypes()
            .then((result) => {
                this.charTypes = result;

                _.forEach(this.charTypes, (charType: Models.ICharacteristicType) => {
                    if (charType.charTypeID == 7) {
                        charType.charTypeName = 'Accounting';
                    }
                });

                this.GetSavedReportParams();
            });
    }

    // calls a search using current state data
    private ExecuteReport() {
        var query = this.reportingChars.map(x => x.tagName);

        var reportRequest: Models.IDynamicReportRequest = {
            ct: this.selectedCharTypeId, // slected char type
            t: this.selectedTemplateId, // selected template
            cols: query, // selected characteristics
            relIndId: this.selectedRelatedTemplatePartyId, // Selected TemplatePartyId
            p: this.page - 1, // the current page
            r: this.rowCount, // rows to return
            sf: this.sortField, // sort Field
            sd: this.sortDir // sort direction 0 - ascending, 1 - descending
        };

        if (this.selectedCharTypeId != null && this.selectedTemplateId != null && this.reportingChars != []) {
            // call service to get the report results
            this.notifyService.startProgress(); // start progress bar
            this.reportService.dynamicReport(reportRequest)
                .then((result) => {
                    this.itemRows = result.resultDocs;
                    this.numFound = result.numFound;
                    this.pageCount = result.pageCount;
                    this.showRelated = true;
                })
                .catch((reason: any) => {
                    alert(this._bustedMessage);
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    private CharTypeChanged() {
        if (this.selectedCharTypeId > 0) {
            this.page = 1; // reset page
            this.selectedTemplateId = null; // reset selected template
            this.selectedChar = null; //clear selected chars
            this.relatedCharTypes = []; //clear related char types
            this.reportingChars = [];
            this.reportingChars = [];
            this.selectedRelatedCharTypeId = null;
            this.relatedTemplates = [];
            this.selectedRelatedTemplateId = null;
            this.selectedRelatedTemplateParties = [];
            this.selectedRelatedTemplatePartyId = null;
            this.allRelatedFilteredChars = [];
            this.showRelated = false;
            this.itemRows = [];
            this.notifyService.startProgress();
            return this.entityConfigService.getCharacteristicTemplates(this.selectedCharTypeId)
                .then((result) => {
                    this.templates = result;
                })
                .catch((reason: any) => {
                    alert(this._bustedMessage);
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        else {
            this.Init();
        }
    }

    private RelatedCharTypeChanged() {
        this.page = 1;
        this.selectedRelatedTemplateId = null;
        this.allRelatedChars = {};
        this.allRelatedFilteredChars = {};
        this.relatedTemplates = [];

        if (this.selectedRelatedCharTypeId > 0) {
            this.notifyService.startProgress();
            var promise1 = this.entityConfigService.getCharacteristicTemplates(this.selectedRelatedCharTypeId)
                .then((result) => {
                    this.relatedTemplates = result;
                })
                .catch((reason: any) => {
                    alert(this._bustedMessage);
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });

            return this.$q.all([promise1]);
        }
    }

    // fired whenever template is changed
    private TemplateChanged() {
        this.page = 1;
        this.selectedChar = null; //clear selected chars
        this.allColumnChars = {};
        this.allColumnFilteredChars = {};
        this.reportingChars = [];

        //get the characteristics for selected CharType and Template
        if (this.selectedCharTypeId > 0 && this.selectedTemplateId > 0) {
            var promise1 = this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.selectedCharTypeId, this.selectedTemplateId).then((result) => {
                for (var i = 0; i < result.length; i++) {
                    var ct = result[i];
                    this.allColumnChars[ct.characteristicID] = { tagName: ct.tagLabel, label: ct.label };
                    this.allColumnFilteredChars[ct.characteristicID] = { tagName: ct.tagLabel, label: ct.label };
                }
            });

            //get the related char types for the selected type and template
            var promise2 = this.entityConfigService.getRelatedCharacteristicTypes(this.selectedCharTypeId).then((result) => {
                _.forEach(result, (charType: Models.ICharacteristicType) => {
                    if (charType.charTypeID == 4) {
                        charType.charTypeName = 'Deal';
                    }
                    if (charType.charTypeID == 5) {
                        charType.charTypeName = 'Table';
                    }
                    if (charType.charTypeID == 1) {
                        charType.charTypeName = 'Catalog Item';
                    }
                    if (charType.charTypeID == 15) {
                        charType.charTypeName = 'Job';
                    }
                    if (charType.charTypeID == 7) {
                        charType.charTypeName = 'Accounting';
                    }
                    this.relatedCharTypes.push(charType);
                });
            });
            return this.$q.all([promise1, promise2]);
        }
    }

    // fired whenever related template is changed
    private RelatedTemplateChanged() {
        this.page = 1;
        this.selectedRelatedChar = null;
        this.allRelatedChars = []; //clear selected chars
        this.allRelatedFilteredChars = [];
        this.notifyService.startProgress();
        var promise1 = this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.selectedRelatedCharTypeId, this.selectedRelatedTemplateId).then((result) => {
            for (var i = 0; i < result.length; i++) {
                var ct = result[i];
                var tagLabel = this.selectedRelatedCharTypeId + "_" + this.selectedRelatedTemplateId + "_" + ct.tagLabel;
                this.allRelatedChars[ct.characteristicID] = { tagName: tagLabel, label: ct.label };
                this.allRelatedFilteredChars[ct.characteristicID] = { tagName: tagLabel, label: ct.label };
            }
            if (this.selectedRelatedCharTypeId == 2) {
                this.entityConfigService.getTemplateParties(this.selectedCharTypeId, this.selectedTemplateId).then((result) => {
                    this.selectedRelatedTemplateParties = result;
                });
            }
            this.notifyService.endProgress();
        });
        return this.$q.all([promise1]);
    }

    private AddCharacteristicToReport(selectedCharID) {
        this.page = 1;
        var selectedChar = this.allColumnFilteredChars[selectedCharID];
        if (!_.isUndefined(selectedChar)) {
            var newReportingChar: Models.IDynamicReportColumnChar = {
                characteristicID: selectedCharID[0],
                label: selectedChar.label,
                tagName: selectedChar.tagName
            };
            this.reportingChars.push(newReportingChar);
            delete this.allColumnFilteredChars[selectedCharID[0]];
        }
    }

    private AddRelatedCharacteristicToReport(selectedRelatedCharID) {
        this.page = 1;
        var rsc = this.allRelatedChars[selectedRelatedCharID];
        if (!_.isUndefined(rsc)) {
            var newReportingChar: Models.IDynamicReportColumnChar = {
                characteristicID: selectedRelatedCharID[0],
                label: rsc.label,
                tagName: rsc.tagName
            };
            this.reportingChars.push(newReportingChar);
            delete this.allRelatedFilteredChars[selectedRelatedCharID[0]];
        }
    }

    public RemoveCharacteristicFromReport(reportingChar: Models.IDynamicReportColumnChar, $event: ng.IAngularEvent) {
        $event.preventDefault();
        if (reportingChar.tagName == this.sortField) {
            this.sortField = "";
        }
        this.page = 1;
        var removedAllColumnChar = this.allColumnChars[reportingChar.characteristicID];
        if (removedAllColumnChar != undefined && removedAllColumnChar.tagName == reportingChar.tagName) {
            this.removedAllColumnCharFromReportingChars = true;
        }
        else {
            this.removedAllColumnCharFromReportingChars = false;
        }

        _.remove(this.reportingChars, rc => rc.characteristicID == reportingChar.characteristicID && rc.tagName == reportingChar.tagName);

        if (this.removedAllColumnCharFromReportingChars) {
            this.allColumnFilteredChars[reportingChar.characteristicID] = removedAllColumnChar;
        } else {
            var removedAllRelatedColumnChar = this.allRelatedChars[reportingChar.characteristicID];
            if (removedAllRelatedColumnChar != undefined) {
                this.allRelatedFilteredChars[reportingChar.characteristicID] = removedAllRelatedColumnChar;
            }
        }

        if (this.reportingChars.length == 0) {
            this.itemRows = [];
            this.pageCount = 0;
        }
    }

    public SaveReportParams() {
        var savedReportingChars = _.cloneDeep(this.reportingChars);

        var oneReport: Models.ISavedQueryReport = {
            reportName: this.reportName,
            charID: this.selectedCharTypeId,
            templateID: this.selectedTemplateId,
            relatedCharID: this.selectedRelatedCharTypeId,
            relatedTemplateID: this.selectedRelatedTemplateId,
            columns: savedReportingChars,
            relIndId: this.selectedRelatedTemplatePartyId
        };

        var storedReportParams = this.storage.get(this._savedDataExportReportKey) || [];
        storedReportParams.push(oneReport);
        this.storage.set(this._savedDataExportReportKey, storedReportParams);
        this.savedQueryReports = this.storage.get(this._savedDataExportReportKey) || [];
        this.reportName = "";
    }

    private GetSavedReportParams() {
        var storedReportParams: Models.ISavedQueryReport[] = this.storage.get(this._savedDataExportReportKey) || [];
        this.savedQueryReports = storedReportParams;
        if (storedReportParams.length > 0) {
            this.savedReportNames.concat(storedReportParams.map(x => x.reportName));
        }
    }

    public ClearSavedReport(report: Models.ISavedQueryReport) {
        if (this.$window.confirm(this._confirmationMessage)) {
            var storedReportParams: Models.ISavedQueryReport[] = this.storage.get(this._savedDataExportReportKey) || [];
            var index = storedReportParams.findIndex(x => x.reportName == report.reportName);

            if (index > -1) {
                storedReportParams.splice(index, 1);
                this.storage.set(this._savedDataExportReportKey, storedReportParams);
                this.GetSavedReportParams();
            }
        }
    }

    public ClearAllSavedReports() {
        if (this.$window.confirm(this._confirmationMessage)) {
            this.storage.set(this._savedDataExportReportKey, null);
            this.GetSavedReportParams();
        }
    }

    private LoadReport() {
        this.selectedCharTypeId = this.selectedReport.charID;
        this.selectedRelatedTemplatePartyId = this.selectedReport.relIndId;
        this.CharTypeChanged()
            .then(() => {
                this.selectedTemplateId = this.selectedReport.templateID;
                this.TemplateChanged()
                    .then(() => {
                        if (this.selectedReport.relatedCharID > 0) {
                            this.selectedRelatedCharTypeId = this.selectedReport.relatedCharID;
                            this.RelatedCharTypeChanged().then(() => {
                                this.selectedRelatedTemplateId = this.selectedReport.relatedTemplateID;
                            });
                        }
                        this.reportingChars = _.cloneDeep(this.selectedReport.columns);
                        this.showRelated = false;
                    });
            });
    }
}